import { readonly, ref } from 'vue';
import { useProductFlags } from '@modules/featureControl';
import { useMemberProduct } from '@composables/useMemberProduct';
import { useProductImagesCtaActions } from './useProductImagesCtaActions';

export const usePartOfCollection = () => {
  const isAdded = ref(false);
  const { isMemberProduct } = useProductFlags();
  const { masterProductUrl, orderedSiblingProductIds } = useMemberProduct();
  const { addCtaItem } = useProductImagesCtaActions();

  const init = () => {
    if (isMemberProduct && orderedSiblingProductIds.value) {
      addCtaItem({
        customCssClass: 'font-small',
        id: 'partOfCollection',
        label: 'PART OF A COLLECTION',
        onClickHandler: () => {},
        url: masterProductUrl.value,
        allowOpeningInNewTab: true,
      });

      isAdded.value = true;
    }
  };

  return {
    init,
    isAdded: readonly(isAdded),
  };
};

export default usePartOfCollection;
